// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"cdfdf757","453":"0ea7dd70"}[chunkId] + ".chunk.js";
};